// extracted by mini-css-extract-plugin
export var fadeIn = "_j1-1";
export var modalContent = "_j1-3";
export var overlay = "_j1-0";
export var popoverContent = "_j1-2";
export var results = "_j1-5";
export var searchInputWrapper = "_j1-4";